export default "__VITE_ASSET__b95c347a__"